<script setup lang="ts">
defineProps({
    as: { type: String, default: 'div' },
});
</script>

<template>
    <UContainer :as="as" class="flex h-full w-full flex-col gap-9 px-0 sm:px-0 lg:px-0 xl:px-0">
        <slot />
    </UContainer>
</template>
